export default "__VITE_ASSET__B8C4Cv6$__"